import { StatusOptions } from '@/models/interface/Common'
import { currencyMask } from '@/models/interface/Masks'
import MediaPackage from '@/models/MediaPackage'

export default {
  name: 'Share Media Package',
  sections: [
    {
      name: 'Package Information',
      fields: [
        {
          name: 'Package Name',
          type: 'text',
          target: 'model_name',
          rules: 'required|min:3|max:255',
          description: 'Enter package name.',
          edit: false,
        },
        {
          name: 'Share Name',
          type: 'text',
          target: 'formName',
          rules: 'required|max:255',
          description: 'Package share name.',
        },
        {
          name: 'Package Price',
          target: 'formRate',
          type: 'number',
          mask: currencyMask,
          rules: 'required',
          description: 'Package share price',
        },
        {
          name: 'Tenant',
          type: 'tenant',
          rules: 'required',
          target: 'tenant_id',
        },
        {
          name: 'Status',
          type: 'picker',
          rules: 'required',
          target: 'status',
          options: StatusOptions,
        },
      ],
    },
  ],
}
